import React from 'react'
import styled from 'styled-components'

import theme from 'theme'

import Content from 'components/blog/Content'
import Article from 'components/Article'
import SocialShareButtons from 'components/SocialShareButtons'

const StyledContent = styled(Content)`
  ol li {
    margin: 18px 0;
  }
`

const Company = styled.div`
  color: ${theme.colors.blacks[40]};
  font-weight: ${theme.fontWeights.bold};
  margin-bottom: -20px;
`

export default function Body ({
  title,
  summary,
  company,
  path,
  content,
  renderBottomAction,
}) {
  return (
    <Article px={[20]} pb={[20, 20, 50]}>
      <StyledContent>
        {company && <Company>{company}</Company>}
        {content}
      </StyledContent>
      <SocialShareButtons
        title={title}
        summary={summary}
        path={path}
        bottomAction={renderBottomAction}
        mt={[36]}
        mb={[80]}
      />
    </Article>
  )
}
